import ThiswayLogo from '../../../assets/logo/logo-black.svg';

const Footer = () => {
  const year = new Date().getFullYear();

  const handleAppStoreClick = (e, storeUrl, deeplinkUrl, androidIntentUrl) => {
    e.preventDefault();

    const userAgent = navigator.userAgent || navigator.vendor || window.opera;

    if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
      // Try deep link silently using iframe to avoid Safari error message
      const iframe = document.createElement('iframe');
      iframe.style.display = 'none';
      iframe.src = deeplinkUrl;
      document.body.appendChild(iframe);

      // If app doesn't open in 1.5s, redirect to App Store
      const timer = setTimeout(() => {
        if (document.body.contains(iframe)) {
          document.body.removeChild(iframe);
        }
        window.location.href = storeUrl;
      }, 1500);

      // Clean up if user returns (app opened)
      window.addEventListener('blur', () => {
        clearTimeout(timer);
        setTimeout(() => {
          if (document.body.contains(iframe)) {
            document.body.removeChild(iframe);
          }
        }, 100);
      });

      return;
    }

    if (/android/i.test(userAgent)) {
      window.location.href = androidIntentUrl || storeUrl;
      return;
    }

    window.open(storeUrl, '_blank');
  };

  return (
    <footer className="mt-4">
      <div className="w-full max-w-5xl mx-auto px-3 py-6">
        <div className="flex flex-col sm:flex-row items-center justify-between gap-6 text-sm text-gray-600">
          <div className="flex items-center gap-2">
            Powered by
            <a href="https://www.thisway.co" rel="noreferrer">
              <img src={ThiswayLogo} alt="Thisway" className="h-6" />
            </a>
          </div>

          {/* App Store Links */}
          <div className="flex justify-center">
            <div className="flex gap-3">
              {/* iOS */}
              <a
                href="https://apps.apple.com/us/app/thisway-co/id6740181672"
                onClick={(e) =>
                  handleAppStoreClick(
                    e,
                    'itms-apps://itunes.apple.com/app/id6740181672',
                    'thisway://open',
                    null
                  )
                }
                target="_blank"
                rel="noreferrer"
                className="transition-transform hover:scale-105"
              >
                <img
                  alt="Thisway iOS app download icon"
                  src="https://cdn.prod.website-files.com/64bf0dc67f53cb40f4a3f4de/68894d12a8d89cdb4e9a3e8d_App%20Store%20Button.svg"
                  className="h-8 w-auto"
                />
              </a>

              {/* Android */}
              <a
                href="https://play.google.com/store/apps/details?id=com.thisway.customerapp.customerapp"
                onClick={(e) =>
                  handleAppStoreClick(
                    e,
                    'https://play.google.com/store/apps/details?id=com.thisway.customerapp.customerapp',
                    'thisway://open',
                    'intent://open#Intent;scheme=thisway;package=com.thisway.customerapp.customerapp;end'
                  )
                }
                target="_blank"
                rel="noreferrer"
                className="transition-transform hover:scale-105"
              >
                <img
                  alt="Thisway Android app download icon"
                  src="https://cdn.prod.website-files.com/64bf0dc67f53cb40f4a3f4de/68894d12a8d89cdb4e9a3e86_Google%20Play%20Button.svg"
                  className="h-8 w-auto"
                />
              </a>
            </div>
          </div>

          <div className="flex flex-col sm:flex-row items-center gap-3 sm:gap-6">
            <a
              href="https://www.thisway.co/terms"
              target="_blank"
              rel="noreferrer"
              className="underline"
            >
              Terms & Conditions
            </a>
            <a
              href="https://www.thisway.co/privacy"
              target="_blank"
              rel="noreferrer"
              className="underline"
            >
              Privacy Policy
            </a>
            <span className="opacity-80">All Rights Reserved. {year}</span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
